import React, { useState } from 'react';
import Modal from '../Modal/Modal';
import SignatureModalContent from './SignatureModalContent';
import { useAppContext } from '../../Services/AppContext';
import Button from '../Button/Button';

interface ISignatureModal {
	userId: string;
}

export default function SignatureModal(props: ISignatureModal) {
	const { userId } = props;
	const { translation } = useAppContext();
	const [modalOpen, setModalOpen] = useState(false);

	return (
		<div>
			<Button
				onClick={() => setModalOpen(true)}
				title={translation['base.signature']}
				theme={'blue'}
				className={'mt-4'}
			/>
			<Modal
				opened={modalOpen}
				onClose={() => setModalOpen(false)}
				fullScreen={false}
			>
				<Modal.Header title='base.signature' />
				<Modal.Content>
					<SignatureModalContent userId={userId} />
				</Modal.Content>
			</Modal>
		</div>
	);
}
